import Router from "next/router"
import { FacebookEvents, sendFacebookEvent } from "./facebook/events"
import { Routes } from "../data/routes"
import { UserState } from "../components/finder/store/finder_store"
import { postDermatologistInterest } from "../api/skinuvita-finder-api"
import { fetchLocation } from "../components/finder/store/nominatim"

export class TrackedActions {
  static goToSelfCheck() {
    console.log("confirm goToSelfCheck")
    sendFacebookEvent(FacebookEvents.Selbstcheck).then(() => Router.push(Routes.selfCheck))
  }

  static async confirmUnfittingLead(userStore: UserState) {
    console.log("confirm unfittingLead")
    await sendFacebookEvent(FacebookEvents.UnfittingLead)
    return await postDermatologistInterest({
      familyName: userStore.lastName,
      givenName: userStore.firstName,
      email: userStore.mail,
      phoneNumber: userStore.phone,
      healthInsurance: userStore.healthInsurance,
      diagnoses: userStore.diagnoses,
      interestConfirmed: userStore.confirmSkinuvitaInterest,
      dataMayBeUsed: userStore.confirmDataUsage,
      zipCode: userStore.plz,
      city: "unfitting insurance",
      street: "unfitting insurance",
      houseNumber: userStore.supportOptions.join(", "),
    })
  }

  static async confirmMatchingLead(userStore: UserState) {
    console.log("confirm matchingLead")
    const locationPromise = fetchLocation(userStore.plz)

    // Do not block UX on lead submission; location lookup decides the next step.
    void sendFacebookEvent(FacebookEvents.MatchingLead)
      .then(async () => {
        const response = await postDermatologistInterest({
          familyName: userStore.lastName,
          givenName: userStore.firstName,
          email: userStore.mail,
          city: "we don't collect this info anymore",
          zipCode: userStore.plz,
          street: "we don't collect this info anymore",
          houseNumber: "we don't collect this info anymore",
          phoneNumber: userStore.phone,
          healthInsurance: userStore.healthInsurance,
          diagnoses: userStore.diagnoses,
          interestConfirmed: null,
          dataMayBeUsed: userStore.confirmDataUsage,
        })
        userStore.setUuid(response.data.uuid)
      })
      .catch((error) => {
        console.error("Failed to submit matching lead", error)
      })

    return locationPromise
  }
}
